import { products as fallbackProducts, type Product } from '@/mocks/products';
import { apiGet, apiSend, apiSendFormData } from '@/lib/api/client';

export async function fetchProducts() {
  return apiGet<Product[]>('/products.php');
}

export async function saveProduct(product: Product) {
  return apiSend<Product>('/products.php', 'POST', product);
}

export async function uploadProductImage(file: File) {
  const formData = new FormData();
  formData.append('image', file);
  const response = await apiSendFormData<{ url: string }>('/products.php?action=upload', 'POST', formData);
  return response.url;
}

export async function deleteProduct(productId: string) {
  return apiSend<null>(`/products.php?id=${encodeURIComponent(productId)}`, 'DELETE');
}

export function getFallbackProducts() {
  return fallbackProducts;
}
